import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { loadServerTime, setServerTime, loadServerTimeFailure } from './system.actions';
import { PlycaDataService } from '../../../../../services/plyca.service';
import moment from 'moment';

@Injectable()
export class SystemEffects {
  private actions$ = inject(Actions);
  private plycaService = inject(PlycaDataService);

  loadServerTime$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadServerTime),
      switchMap(() =>
        this.plycaService.getAttributeValue('FECHA_ACTUAL_STD').pipe(
          map((result: any) => {
            if (result && result.values && result.values.length > 0) {
              const dateStr = result.values[0].columns['FECHAACTUAL'].value;
              const serverTime = moment(dateStr, 'DD-MM-YYYY HH:mm:ss').toDate();
              return setServerTime({ serverTime });
            }
            return loadServerTimeFailure({ error: 'No data returned' });
          }),
          catchError((error) => of(loadServerTimeFailure({ error })))
        )
      )
    )
  );
}
